// extracted by mini-css-extract-plugin
export default {"card":"C8y3E","header":"nxmm3","inner":"Ba9Ps","item":"tqDUl","itemText":"mUtXs"};